export function workOrderTypes() {
  return [
    { code: 'I', name: 'Install' },
    { code: 'A', name: 'Additional' },
    { code: 'H', name: 'Healthy Check' },
    { code: 'M', name: 'Maintenance' },
    { code: 'U', name: 'Uninstall' },
    { code: 'P', name: 'Pindah Unit' },
  ]
}
